import {AnimationItem} from 'lottie-web/build/player/lottie_light';
import {MutableRefObject} from 'react';
import AutoScrollButton from './AutoScrollButton';
import CommentButton from './CommentButton';
import styles from './ControllBar.module.scss';
import NextButton from './NextButton';
import PrevButton from './PrevButton';
import RunModeButton from './RunModeButton';
import {IViewType} from '../../type';

interface IProps {
  isShow: boolean;
  isPrevInactive: boolean;
  isNextInactive: boolean;
  isStopSales: boolean;
  isRunMode: boolean;
  runModeRef: MutableRefObject<AnimationItem | undefined>;
  viewType: IViewType;
  onClickPrevEpisode: () => void;
  onClickComment: () => void;
  onClickRunMode: () => void;
  onClickNextEpisode: () => void;
  onClickAutoScroll: () => void;
}

export default function ControllBar({
  isShow,
  isPrevInactive,
  isNextInactive,
  isStopSales,
  isRunMode,
  runModeRef,
  viewType,
  onClickPrevEpisode,
  onClickComment,
  onClickRunMode,
  onClickNextEpisode,
  onClickAutoScroll,
}: IProps) {
  return (
    <div
      className={cn(
        'fixed w-full bottom-32 flex justify-center z-navigationBar',
        {
          hidden: !isShow,
        }
      )}
      onClick={e => e.stopPropagation()}
    >
      <div className="flex justify-between w-[312px]">
        <PrevButton
          className={cn({
            [styles.inactive]: isPrevInactive || isRunMode,
          })}
          onClick={onClickPrevEpisode}
        />
        <CommentButton disabled={isStopSales} onClick={onClickComment} />
        <RunModeButton
          lottieRef={runModeRef}
          onClick={onClickRunMode}
          isRunMode={isRunMode}
        />
        <AutoScrollButton
          onClick={onClickAutoScroll}
          disabled={viewType === 'page'}
        />
        <NextButton
          className={cn({
            [styles.inactive]: isNextInactive || isRunMode,
          })}
          onClick={onClickNextEpisode}
        />
      </div>
    </div>
  );
}
